import React from 'react';
import './MapTable.css';

const MapTable = ({ points, progress, sentPoints }) => {
  return (
    <div className="map-table-container">
      <h2>Points</h2>
      <div className="map-upload-progress">
        <p>Rendered Points: {points.length}</p>
        {progress.total > 0 && (
          <>
            <p>Progress: {progress.current}/{progress.total}</p>
            <div className="progress-bar-container">
              <div 
                className="progress-bar-fill"
                style={{ 
                  width: `${progress.total > 0 ? (progress.current / progress.total) * 100 : 0}%` 
                }}
              />
            </div>
          </>
        )}
      </div>
      <table className="map-data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>ID</th>
            <th>Name</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Radius</th>
            <th>Interactivity</th>
            <th>Visited</th>
            <th>Start</th>
            <th>End</th>
            <th>Uid</th>
          </tr>
        </thead>
        <tbody>
          {points.map((point, index) => (
            <tr
              key={index}
              className={index % 2 === 0 ? 'even-row' : 'odd-row'}
              style={{ backgroundColor: sentPoints.includes(index) ? 'lightgreen' : 'transparent' }}
            >
              <td>{index + 1}</td>
              <td>{point.id}</td>
              <td>{point.name}</td>
              <td>{point.coordinates.latitude}</td>
              <td>{point.coordinates.longitude}</td>
              <td>{point.radius}</td>
              <td>{point.interactivity}</td>
              <td>{point.visited ? 'Yes' : 'No'}</td>
              <td>{point.start}</td>
              <td>{point.end}</td>
              <th><a href={`/vote/${point.uid}`}>{point.uid}</a></th>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MapTable;
